/**
 * --------------------------------------------------------------------------
 * Basic Modules: LayoutSections.js
 * --------------------------------------------------------------------------
 */

import Util from "./util";

/**
 * ------------------------------------------------------------------------
 * Constants
 * ------------------------------------------------------------------------
 */

const DEBUG             = false;
const NAME              = 'layoutSections';
const DATA_KEY          = NAME;
const EVENT_KEY         = `.${DATA_KEY}`;
const LOG_KEY           = `[${NAME}]`;

const Default = {
    scrollPollInterval  : 250,
    scrollThreshold     : 5,
};

const Event = {
    RESIZE              : `resize${EVENT_KEY} orientationchange${EVENT_KEY}`,
    SCROLL              : `scroll${EVENT_KEY}`,
    CLICK               : `click${EVENT_KEY}`,
};

const ClassName = {
    CONTENT             : 'c\:section-content',
};

const Selector = {
    TOGGLE              : '[data-layout]',
    WRAPPER             : '.ccm-custom-style-container',
    CONTAINER           : '.container',
    LAYOUT              : '[data-layout]',
    CONTENT             : '> .row > .col-md-12',
};

const DataAttr = {
};

class LayoutSections {

    constructor(element, config) {

        DEBUG && console.log(LOG_KEY, 'Init');

        this.resizeTimeout = null;
        this.scrollInitialized = false;

        this._element = element;
        this._config  = this._getConfig(config);

        this._init();

        //this._addEventListeners();
    }

    destroy() {
        $(this._element).off(EVENT_KEY);
        $.removeData(this._element, DATA_KEY);
        this._element = null;
    }

    // Private

    _init() {

        // Find the wrapper
        let $wrapper = this._getWrapper();
        let backgroundImage = $(this._element).attr('data-background-image');

        $wrapper.addClass($(this._element).data('class'));

        if (backgroundImage) {
            $wrapper.attr('data-background-image', $(this._element).attr('data-background-image'));
        }

        $(this._element).find(Selector.CONTENT).addClass(ClassName.CONTENT);
    }

    _getWrapper() {

        let $wrapper = $(this._element).closest(Selector.WRAPPER);

        if (! $wrapper[0]) {
            let $container = $(this._element).closest(Selector.CONTAINER);

            // Wrap the container into a div
            $container.wrap('<div></div>');
            $wrapper = $container.parent();
        }

        return $wrapper;
    }

    _isMobile() {
        return Util.viewport === 'mobile';
    }

    _addEventListeners() {
        $(window).on(Event.RESIZE, (event) => this._handleWindowResize(event));
        this._handleScroll();
    }

    /**
     * Handle the resizing of the window
     * @private
     */
    _handleWindowResize() {

        if (this.resizeTimeout) return;

        // do stuff when window is resized.

        this.resizeTimeout = setTimeout(() => {
            this.resizeTimeout = null;
        }, 500);
    }

    _handleScroll() {

        if (this.scrollInitialized === false) {

            let didScroll = false;
            let lastScrollTop = 0;

            this.scrollInitialized = true;

            $(window).on(Event.SCROLL, () => {
                didScroll = true;
            });

            // Polling the scrolling and run hasScrolled() and reset didScroll status
            setInterval(() => {
                if (didScroll) {
                    hasScrolled(); // function where stuff gets done.
                    didScroll = false;
                }
            }, this._config.scrollPollInterval);

            const hasScrolled = () => {
                let scrollTop = $(window).scrollTop();
                let distance  = Math.abs(scrollTop - lastScrollTop);

                if (distance <= this._config.scrollThreshold) { // delta
                    // Don't do anything when scrolling doesn't exceed scrolling threshold
                    return;
                }

                // Do stuff here:
                if (scrollTop > 0) {}

                // End stuff here

                lastScrollTop = scrollTop;
            }
        }
    }

    _getConfig(config) {
        return {
            ...Default,
            ...config
        };
    }

    // Static

    /**
     * Convenient static method to initiate the module.
     *
     * @param config
     * @param selector
     */
    static bind (config, selector) {
        LayoutSections._jQueryInterface.call($(selector || Selector.TOGGLE), config);
    }

    /**
     * jQuery Interface
     * @param config
     * @returns {*}
     */
    static _jQueryInterface(config) {
        return this.each(function() {
            const $this = $(this);
            let data    = $this.data(DATA_KEY);
            let _config = {
                ...Default,
                ...$this.data(),
                ...typeof config === 'object' && config ? config : {}
            };

            if (!data) {
                data = new LayoutSections(this, _config);
                $this.data(DATA_KEY, data);
            }

            if (typeof config === 'string') {
                if (typeof data[config] === 'undefined') {
                    throw new TypeError(`No method named "${config}"`);
                }
                data[config]();
            }
        });
    }
}

/**
 * ------------------------------------------------------------------------
 * jQuery
 * ------------------------------------------------------------------------
 */

$.fn[NAME] = LayoutSections._jQueryInterface;
$.fn[NAME].Constructor = LayoutSections;


export default LayoutSections;
